import { Card, Descriptions, Form, Modal, Statistic, Steps } from 'antd';
import styled from 'styled-components';
import { APP_SHELL_THEME } from '@/styles/appShellTheme';

export const StyledModal = styled(Modal)`
  &.ant-modal {
    top: 56px;

    .ant-modal-content {
      display: flex;
      flex-direction: column;
      min-height: 788px;

      .ant-modal-body {
        display: flex;
        flex-grow: 1;

        .ant-form {
          flex-grow: 1;
          display: flex;
          flex-direction: column;
          justify-content: space-between;
        }
      }
    }
  }
`;

export const StyledSteps = styled(Steps)`
  max-width: 832px;
  margin: 32px auto;

  .ant-steps-item-icon {
    font-weight: 600;
  }

  .ant-steps-item-icon .ant-steps-icon {
    color: ${APP_SHELL_THEME.text} !important;
  }

  .ant-steps-item-title {
    color: rgba(${APP_SHELL_THEME.overlayRgb}, 0.5) !important;
    font-weight: 400;
  }

  .ant-steps-item-description {
    color: ${APP_SHELL_THEME.textMuted} !important;
  }

  /* Current step — strong contrast */
  .ant-steps-item-process .ant-steps-item-icon {
    background-color: ${APP_SHELL_THEME.accent} !important;
    border-color: ${APP_SHELL_THEME.accent} !important;
    box-shadow: 0 0 0 3px rgba(97, 97, 215, 0.35);
  }

  .ant-steps-item-process .ant-steps-item-icon .ant-steps-icon {
    color: ${APP_SHELL_THEME.onAccent} !important;
  }

  .ant-steps-item-process .ant-steps-item-title {
    color: ${APP_SHELL_THEME.text} !important;
    font-weight: 600;
  }

  /* Completed steps */
  .ant-steps-item-finish .ant-steps-item-title {
    color: rgba(${APP_SHELL_THEME.overlayRgb}, 0.88) !important;
  }

  .ant-steps-item-finish .ant-steps-item-icon {
    background-color: ${APP_SHELL_THEME.filterInputBg} !important;
    border-color: ${APP_SHELL_THEME.accent} !important;
  }

  .ant-steps-item-finish .ant-steps-item-icon .ant-steps-icon {
    color: ${APP_SHELL_THEME.text} !important;
  }

  /* Upcoming steps */
  .ant-steps-item-wait .ant-steps-item-title {
    color: rgba(${APP_SHELL_THEME.overlayRgb}, 0.42) !important;
  }

  .ant-steps-item-wait .ant-steps-item-icon {
    background-color: rgba(${APP_SHELL_THEME.overlayRgb}, 0.1) !important;
    border-color: ${APP_SHELL_THEME.panelBorder} !important;
  }

  .ant-steps-item-wait .ant-steps-item-icon .ant-steps-icon {
    color: ${APP_SHELL_THEME.text} !important;
  }

  .ant-steps-item-finish > .ant-steps-item-container > .ant-steps-item-tail::after,
  .ant-steps-item-process > .ant-steps-item-container > .ant-steps-item-tail::after {
    background-color: ${APP_SHELL_THEME.accent} !important;
  }

  .ant-steps-item-wait > .ant-steps-item-container > .ant-steps-item-tail::after {
    background-color: rgba(97, 97, 215, 0.28) !important;
  }
`;

export const StyledForm = styled(Form)`
  margin-top: 40px;
`;

export const StyledStatisticCard = styled(Card)`
  height: 100%;
  background-color: ${APP_SHELL_THEME.filterInputBg};
  border-color: ${APP_SHELL_THEME.panelBorder};

  .ant-card-body {
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
  }
`;

export const StyledDescriptionCard = styled(Card)`
  background-color: ${APP_SHELL_THEME.panelBg};
  border-color: ${APP_SHELL_THEME.panelBorder};

  .ant-card-body {
    padding: 16px;
  }
`;

export const StyledDescriptions = styled(Descriptions)`
  .ant-descriptions-item-label,
  .ant-descriptions-item-content {
    font-size: 16px;
    color: rgba(${APP_SHELL_THEME.overlayRgb}, 0.92);
  }

  .ant-descriptions-item-label {
    font-weight: 500;
    color: ${APP_SHELL_THEME.textMuted};
  }

  .ant-descriptions-item-content {
    font-weight: 400;
  }

  .ant-descriptions-row:nth-child(2) {
    .ant-descriptions-item-content {
      padding-bottom: 10px;
    }
  }

  &.ant-descriptions-small .ant-descriptions-row > th,
  &.ant-descriptions-small .ant-descriptions-row > td {
    padding-bottom: 0;
  }
`;

export const StyledStatistic = styled(Statistic)`
  display: flex;
  flex-direction: column;
  align-items: center;

  .ant-statistic-content-value {
    color: rgba(${APP_SHELL_THEME.overlayRgb}, 0.95);
    font-weight: 500;
  }

  .ant-statistic-title {
    color: ${APP_SHELL_THEME.textMuted};
  }
`;
